export default __webpack_public_path__ + "static/media/Drop.96e311ed.svg";